<template>
  <div>
    <div class="wrapHeader">
      <el-form :inline="true" :model="params" class="demo-form-inline">
        <el-form-item label="仓房名称">
          <el-input v-model="params.wareName" placeholder="输入仓房名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getInfo">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      params:{

      }
    }
  },
  created(){

  },
  methods:{
    getInfo(){}
  }
}
</script>

<style lang="scss" scoped>

</style>

